module.exports = __webpack_public_path__ + "static/media/4.8222fc60.jpg";